import fetch from '../utils/request'

// 查询平台统计数据
export function GetPlatFormStatistics(params) {
    return fetch('finance/platform/statistics', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 注册报表
export function GetRegisterReportStatistics(params) {
    return fetch('reportstatistics/register', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 登录报表
export function GetLoginReportStatistics(params) {
    return fetch('reportstatistics/login', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 充值报表
export function GetRechargeReportStatistics(params) {
    return fetch('reportstatistics/recharge', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 组局报表
export function GetPrivateTeamReportStatistics(params) {
    return fetch('reportstatistics/privateteam', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 房卡消耗报表
export function GetRoomCardReportStatistics(params) {
    return fetch('reportstatistics/roomcard', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询订单列表
export function GetOrderList(params) {
    return fetch('business/order/list', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询代理申请列表
export function GetAgentApplyLog(params) {
    return fetch('finance/agent/apply/log', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询代理列表
export function GetAgentList(params) {
    return fetch('finance/agent/list', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询返点列表
export function GetRebateList(params) {
    return fetch('finance/rebate/list', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 修改代理审核状态
export function UpdateAgentApplyStatus(params) {
    return fetch('finance/agent/apply/update', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询游戏私人房组局日志
export function GetGamePrivateLog(params) {
    return fetch('game/private/log', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 代理申请通过/拒绝
export function ModifyAgentApplyState(params) {
    return fetch('finance/agent/apply/state/modify', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 删除代理申请
export function DeleteAgentApply(params) {
    return fetch('finance/agent/apply/delete', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询第一个返点的代理
export function GetAgentFirstInfo(params) {
    return fetch('finance/agent/first/info', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询平台统计详情
export function GetPlatFormStatisticsDetails(params) {
    return fetch('finance/platform/statistics/details', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 查询在线人数列表
export function GetPlatFormOnlineStatistics(params) {
    return fetch('finance/platform/onlinestatistics', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

